// popup initiate

const showDialogButtons = document.querySelectorAll(".show-dialog");
const dialog = document.getElementById("dialog");
const hideDialog = document.querySelector(".close-dialog");

showDialogButtons.forEach((button) => {
  button.addEventListener("click", () => {
    dialog.showModal();
    $("body").addClass("body-disabled");
  });
});

// hideDialog.addEventListener("click", () => {
//   dialog.close();
//   $("body").removeClass("body-disabled");
// });
$(".close-dialog").on("click", function () {
  dialog.close();
  $("body").removeClass("body-disabled");
});

dialog.addEventListener("click", (e) => {
  if (e.target.tagName === "DIALOG") {
    dialog.close();
  }
});

//step form

/**
 * Define a function to navigate betweens form steps.
 * It accepts one parameter. That is - step number.
 */
const navigateToFormStep = (stepNumber) => {
  /**
   * Hide all form steps.
   */
  document.querySelectorAll(".form-step").forEach((formStepElement) => {
    formStepElement.classList.add("d-none");
  });
  /**
   * Mark all form steps as unfinished.
   */
  document.querySelectorAll(".form-stepper-list").forEach((formStepHeader) => {
    formStepHeader.classList.add("form-stepper-unfinished");
    formStepHeader.classList.remove(
      "form-stepper-active",
      "form-stepper-completed"
    );
  });
  /**
   * Show the current form step (as passed to the function).
   */
  document.querySelector("#step-" + stepNumber).classList.remove("d-none");
  /**
   * Select the form step circle (progress bar).
   */
  const formStepCircle = document.querySelector(
    'li[step="' + stepNumber + '"]'
  );
  /**
   * Mark the current form step as active.
   */
  formStepCircle.classList.remove(
    "form-stepper-unfinished",
    "form-stepper-completed"
  );
  formStepCircle.classList.add("form-stepper-active");
  window.scrollTo(0, 0);
  /**
   * Loop through each form step circles.
   * This loop will continue up to the current step number.
   * Example: If the current step is 3,
   * then the loop will perform operations for step 1 and 2.
   */
  for (let index = 0; index < stepNumber; index++) {
    /**
     * Select the form step circle (progress bar).
     */
    const formStepCircle = document.querySelector('li[step="' + index + '"]');
    /**
     * Check if the element exist. If yes, then proceed.
     */
    if (formStepCircle) {
      /**
       * Mark the form step as completed.
       */
      formStepCircle.classList.remove(
        "form-stepper-unfinished",
        "form-stepper-active"
      );
      formStepCircle.classList.add("form-stepper-completed");
    }
  }
};
/**
 * Select all form navigation buttons, and loop through them.
 */
document
  .querySelectorAll(".btn-navigate-form-step")
  .forEach((formNavigationBtn) => {
    /**
     * Add a click event listener to the button.
     */
    formNavigationBtn.addEventListener("click", () => {
      /**
       * Get the value of the step.
       */
      const stepNumber = parseInt(
        formNavigationBtn.getAttribute("step_number")
      );
      /**
       * Call the function to navigate to the target form step.
       */
      navigateToFormStep(stepNumber);
      window.scrollTo(0, 0);
    });
  });

// show hide step form

$(document).ready(function () {
  $("#start-upload").click(function () {
    $(".step-form").addClass("show");
    $(".ag-main-popup-first.flex").addClass("hide");
    $("#dialog").scrollTop(0);
  });
});

$(document).ready(function () {
  $("#help-sec").click(function () {
    $(".step-form").addClass("hide");
    $(".help-section").addClass("show");
  });
});

$(document).ready(function () {
  $(".first-btns button.help-btn").click(function () {
    $(".step-form").addClass("hide");
    $(".help-section").addClass("show");
  });
});

$(document).ready(function () {
  $(".show-dialog").click(function () {
    $(".help-section").removeClass("show");
    $(".step-form").removeClass("hide");
  });
});

$(document).ready(function () {
  $("#close-dialog").click(function () {
    $(".help-section").removeClass("show");
    $(".step-form").removeClass("hide");
  });
});

jQuery("input#maria-alex-subtitle").change(function () {
  if (jQuery(this).is(":checked")) {
    jQuery(".title-and-sub-title-only").addClass("show");
    jQuery(".title-only").addClass("hide");
  }
});

jQuery("input#maria-alex-title").change(function () {
  if (jQuery(this).is(":checked")) {
    jQuery(".title-only").removeClass("hide");
    jQuery(".title-and-sub-title-only").removeClass("show");
  }
});

// playSound
$("body").on("click", ".playSound", function () {
  $("audio").each(function () {
    this.pause(); // Stop playing
    this.currentTime = 0; // Reset time
  });

  $(".audio-examples-wrap")
    .find("button")
    .removeClass("stopSound is-selected")
    .addClass("playSound");
  $(this).addClass("stopSound is-selected").removeClass("playSound");

  var id = $(this).attr("data-id");
  document.getElementById(id).play();
});

$("body").on("click", ".stopSound", function () {
  $(this).addClass("playSound").removeClass("stopSound");

  var id = $(this).attr("data-id");
  document.getElementById(id).pause();
  document.getElementById(id).currentTime = 0;
});

// version 2
$(document).ready(function () {
  //   var attr = $('#audio1').attr('data-src')
  //   var obj = document.createElement("audio");
  //   obj.src= attr;
  //   obj.volume=1;
  //   obj.autoPlay=true;
  //   obj.preLoad=true;
  //   $(".playSound").click(function() {
  //       obj.play();
  //   });
  //   $(".stopSound").click(function() {
  //     obj.pause()
  //     obj.currentTime = 0;
  //   });
});

$("span#myBtn2").on("click", function () {
  $(".dialog").scrollTop(0);
});

$(".btn-navigate-form-step").on("click", function () {
  $(".dialog").scrollTop(0);
});

$('.skip-btn').on('click', function(){
  var step_number = $(this).attr('step_number');
  if(step_number == '3'){
    $('input[name="main-name-only"]').val('');
    $('input[placeholder="TITLE"]').val('');
    $('input[placeholder="SUBTITLE"]').val('');
  }
  if(step_number == '4'){
    $('textarea[name="main-msg"]').val('');
  }
  navigateToFormStep(step_number);
  window.scrollTo(0, 0);
  $(".dialog").scrollTop(0);
});
